import React, {useCallback, useEffect, useState} from 'react'
import {Button, Typography, withStyles} from '@material-ui/core';
import styles from './styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import {SideNavLayout} from '../../../layouts';
import {LoadingWrapper,} from '../../../components';
import customersService from '../../../services/backend/customersService';
import useShipperOptions from '../../../hooks/useShipperOptions';
import SpecialDeliveryDayFilter from '../../../components/SpecialDeliveryDay/Filter';
import SpecialDeliveryDayTable from '../../../components/SpecialDeliveryDay/SpecialDeliveryDayTable';
import {displayModes} from '../../../services/enums/displayModes';
import {Add as AddIcon} from '@material-ui/icons';
import CreateSpecialDeliveryDayDialog from '../../../components/SpecialDeliveryDay/SpecialDeliveryDayCreateDialog';
import {AuthService} from '../../../services/auth/authService';
import useMicroHubOptionsOfCarrier from '../../../hooks/useMicroHubOptionsOfCarrier';

function SpecialDeliveryDays(props) {
  const {classes, t} = props;

  const [backendLoading, setBackendLoading] = useState(false);
  const [specialDeliveryDays, setSpecialDeliveryDays] = useState([]);
  const [filter, setFilter] = useState({
    shipperName: '',
    carrierName: AuthService.getUserOrganization(),
    microHubName: '',
  });
  const {shipperOptions} = useShipperOptions();
  const {microHubOptions} = useMicroHubOptionsOfCarrier(AuthService.getUserOrganization());
  const [createSpecialDeliveryDayDialogState, setCreateSpecialDeliveryDayDialogState] = useState(false)


  const loadSpecialDeliveryDays = useCallback(async () => {
    setBackendLoading(true);
    try {
      const specialDeliveryDays = await customersService.getSpecialDeliveryDaysByFilter(filter.shipperName, filter.carrierName, filter.microHubName);
      setSpecialDeliveryDays(specialDeliveryDays);
      setBackendLoading(false);
    } catch (error) {
      alert(`${t('errorLoadingSpecialDeliveryDays')}, ${error}`);
      setBackendLoading(false);
    }
  }, [filter.carrierName, filter.microHubName, filter.shipperName, t]);


  useEffect(() => {
    loadSpecialDeliveryDays();
  }, [loadSpecialDeliveryDays]);

  const handleCreateBoxTypeCancel = () => {
    setCreateSpecialDeliveryDayDialogState(false);
  };

  const handleCreateSpecialDeliveryDayClose = (specialDeliveryDay) => {
    specialDeliveryDay.carrierName = filter.carrierName
    customersService.createSpecialDeliveryDaysForMultipleHubs(specialDeliveryDay).then(() => loadSpecialDeliveryDays(), () => alert(t('errorUpdatingData')))
    setCreateSpecialDeliveryDayDialogState(false);
  };

  const handleDeleteSpecialDeliveryDay = (specialDeliveryDay) => {
    customersService.deleteSpecialDeliveryDayById(specialDeliveryDay.id).then(() => loadSpecialDeliveryDays(), () => alert(t('errorDeletingSpecialDeliveryDay')))
  }

  return (
    <SideNavLayout title={t('specialDeliveryDays')}>
      <div className={classes.root}>
        <div className={classes.filterWrapper}>
          <SpecialDeliveryDayFilter
            filter={filter}
            microHubOptions={microHubOptions}
            setFilter={setFilter}
            shipperOptions={shipperOptions}
          />
        </div>
        <div className={classes.headerWrapper}>
          <Typography>
            {t('specialDeliveryDayExplanation')}
          </Typography>
          <Button
            className={classes.addButton}
            color="primary"
            onClick={() => setCreateSpecialDeliveryDayDialogState(true)}
            title={t('createBoxType')}
            variant="contained"
          >
            <AddIcon/>&nbsp;{t('createSpecialDeliveryDay')}
          </Button>
          <br/>
          <br/>
        </div>
        <LoadingWrapper loading={backendLoading}>
          {specialDeliveryDays &&
            <SpecialDeliveryDayTable
              className={classes.content}
              deleteSpecialDeliveryDay={handleDeleteSpecialDeliveryDay}
              displayMode={displayModes.carrier}
              specialDeliveryDays={specialDeliveryDays}
            />
          }
        </LoadingWrapper>
        <CreateSpecialDeliveryDayDialog
          createSpecialDeliveryDayDialogState={createSpecialDeliveryDayDialogState}
          handleCancel={handleCreateBoxTypeCancel}
          handleClose={handleCreateSpecialDeliveryDayClose}
          microHubOptions={microHubOptions}
          shipperOptions={shipperOptions}
        />
      </div>
    </SideNavLayout>
  );
}

SpecialDeliveryDays.propTypes = {
  classes: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};


export default compose(withStyles(styles), withTranslation())(SpecialDeliveryDays);
